import axios, { AxiosResponse } from 'axios';

export type ZipRange = number | [number, number];
export interface TDropdownOptionsRes {
  id: number;
  dropdown_group_id?: number;
  label: string;
  value: string;
  type?: string;
  zip_ranges?: ZipRange[];
}

export const getTradovateTemplateAccounts = (): Promise<
  AxiosResponse<TDropdownOptionsRes[]>
> => {
  return axios.get(`dropdown/tradovate-template-accounts/`);
};

export const getCountries = (): Promise<
  AxiosResponse<TDropdownOptionsRes[]>
> => {
  return axios.get(`dropdown/countries/`);
};

export const getStates = (): Promise<AxiosResponse<TDropdownOptionsRes[]>> => {
  return axios.get(`dropdown/states/`);
};
